<div class="modal-header">
    <h4 class="modal-title">Aviso de su Periodo de Prueba</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <div class="container text-center">
        <div class="trial-icon mb-4">
            <i class="fa-solid fa-calendar-days fa-4x text-warning"></i>
        </div>

        <h2 class="mb-3">¡Estás a la mitad de tu periodo de prueba!</h2>

        <p class="lead mb-4">
            Has experimentado las funcionalidad desde nuestro sistema.
            Le recordamos que para continuar utilizando LubriKuv para mejorar tu negocio,
            te recomendamos suscribirte ahora.
        </p>

        <div class="benefits-section mb-4">
            <h5 class="mb-3">Beneficios de suscribirte:</h5>
            <ul class="list-unstyled text-start mx-auto" style="max-width: 400px;">
                <li class="mb-2">
                    <i class="fa-solid fa-check-circle text-success me-2"></i>
                    Acceso completo a todas las funcionalidades
                </li>
                <li class="mb-2">
                    <i class="fa-solid fa-check-circle text-success me-2"></i>
                    Soporte técnico prioritario
                </li>
                <li class="mb-2">
                    <i class="fa-solid fa-check-circle text-success me-2"></i>
                    Uso de la aplicación móvil para clientes
                </li>
                <li class="mb-2">
                    <i class="fa-solid fa-check-circle text-success me-2"></i>
                    Resumen semanal via correo electrónico
                </li>
                 <li class="mb-2">
                    <i class="fa-solid fa-check-circle text-success me-2"></i>
                    Actualizaciones automáticas
                </li>
                <li class="mb-2">
                    <i class="fa-solid fa-check-circle text-success me-2"></i>
                    Y mucho más...
                </li>
            </ul>
        </div>

        <div class="alert alert-info" role="alert">
            <i class="fa-solid fa-info-circle me-2"></i>
            Te quedan <strong>3 días</strong> de prueba gratuita
        </div>

        <button type="button" class="btn btn-success btn-lg w-100 my-3 py-3" (click)="abrirModalSuscripcion()">
            <i class="fa-solid fa-crown me-2"></i> Suscribirme Ahora
        </button>

        <hr class="my-4">

        <div class="support-section">
            <h5 class="mb-3">¿Necesitas ayuda?</h5>

            <div class="d-flex flex-row align-items-center gap-2 justify-content-center">
                <button type="button" class="btn btn-outline-primary btn-block w-100 my-2 py-2" (click)="email()">
                    <i class="fa-solid fa-envelope me-2"></i> Correo Electrónico
                </button>

                <button type="button" class="btn btn-outline-success btn-block w-100 my-2 py-2" (click)="whatsApp()">
                    <i class="fa-brands fa-whatsapp me-2"></i> WhatsApp 
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="cancelar()">Recordarme más tarde</button>
</div>